import { checkIsSensitive } from '@/apis/app'

// 判断是否为有效外链
export const isExternal = (path: string):boolean => {
    const reg = /^(https?:|mailto:|tel:)/
    return reg.test(path)
}

// 判断是否为有效数组
export const isArray = (arg: any):boolean => {
    if (typeof Array.isArray === 'undefined') {
        return Object.prototype.toString.call(arg) === '[object Array]'
    }
    return Array.isArray(arg)
}

// 判断是否为有效 url
export const isValidURL = (url: string):boolean => {
    const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
    return reg.test(url)
}

// 判断是否为 https 开头有效链接
export const isHttpsURL = (url: string):boolean => {
    const reg = /^(https):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
    return reg.test(url)
}

// 判断是否为有效密码（）
export const isValidPassword = (val: string):boolean => {
    const reg = /^[a-zA-Z]\w{5,17}$/
    return reg.test(val)
}

// 判断是否为有效手机号
export const isValidTel = (val: string):boolean => {
    const reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
    return reg.test(val)
}

// 判断是否为有效固话（座机），如果加区号，必须以 - 分隔，格式：010-12345678
export const isValidMob = (val: string):boolean => {
    const reg = /^((0\d{2,3})-)?(\d{7,8})$/
    return reg.test(val)
}
export const isValidMobile = (val: string): boolean => {
    const reg = /^(0\d{2,3})-?(\d{7,8})$/;
    const reg400 = /^400[- ]?\d{3,4}[- ]?\d{3,4}$/; // 400 电话
    return reg.test(val) || reg400.test(val);
};
// 判断是否为有效邮箱
export const isValidEmail = (val: string):boolean => {
    const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
    return reg.test(val)
}

// 是否包含敏感词
export const isSensitive = async (str) => {
    if (!str) return true
    const { code, data } = await checkIsSensitive(str) as any
    if (code != 200) {
        return data.msg
    } else if (data.conclusionType == 1) {
        return true
    } else {
        return `${ data.data[0].hits.map(item => item.words).join(',')}`
    }
}

// 是否为有效颜色
export const isValidColor = (color) => {
    let colorRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
    return colorRegex.test(color);
}

// 是否为有效身份证号码
export const isValidIdCard = (cardNo: string) => {
    let idCardRegex = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    return idCardRegex.test(cardNo);
}